/*
 * Date: 2020-07-29 15:11:47
 * LastEditors: Mosuzi
 * LastEditTime: 2020-07-29 15:39:07
 * Description: In User Settings Edit
 * Author: Mosuzi
 */
export const SET_CURRENT_FIELD = 'SET_CURRENT_FIELD'

const profileStore = {
  namespaced: true,
  state: {
    currentField: {
      field: null,
      textarea: false
    }
  },
  mutations: {
    [SET_CURRENT_FIELD](state, currentField) {
      state.currentField = currentField
    }
  }
}

export default profileStore
